module.exports = __webpack_public_path__ + "static/media/exercise.5711a1cf.jpeg";